const cookieCategory = {
	Necessary: 'C0001',
	Performance: 'C0002',
	Functional: 'C0003',
	Targeting: 'C0004',
	Social: 'C0005'
} as const;

export default cookieCategory;
